import { create } from 'zustand';

export interface CopilotTask {
  id: string;
  title: string;
  description?: string;
}

interface CopilotState {
  isOpen: boolean;
  activeTask: CopilotTask | null;

  openGeneral: () => void;
  openForTask: (task: CopilotTask) => void;
  close: () => void;
}

export const useCopilotStore = create<CopilotState>((set) => ({
  isOpen: false,
  activeTask: null,

  openGeneral: () => set({ isOpen: true, activeTask: null }),
  openForTask: (task) => set({ isOpen: true, activeTask: task }),
  close: () => set({ isOpen: false, activeTask: null }),
}));
